// extracted by mini-css-extract-plugin
module.exports = {"root":"TaskPerson_root__sVxNy","avatar":"TaskPerson_avatar__20S9K","name":"TaskPerson_name__38GBj","delete":"TaskPerson_delete__UGVTG"};